import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import type { Observable } from 'rxjs';

const MOCK_CANNES_AP_SSID = 'MOCK-CANNES-AP';

/**
 * Short-circuits the whole provisioning flow — no BLE writes, no 1.5s/12s AP-settle delays, no
 * native WiFi join — returning a fake SSID immediately so `HuntingProductsEffects`' downstream
 * flow (which only consumes the emitted SSID) runs unchanged.
 */
@Injectable()
export class MockCannesWifiConnectionService {
  provisionAndConnect$(_deviceId: string): Observable<string> {
    return of(MOCK_CANNES_AP_SSID);
  }
}
